<div
  class="incentive-pool-banner flex-col sm:flex-row sm:items-center flex gap-3 sm:gap-5 px-4 py-3 bg-white rounded-xl shadow-sm border border-slate-200 border-l-4 border-l-emerald-600 flex-wrap"
  [class.incentive-pool-banner--error]="hasError()"
  role="region"
  aria-label="Deal incentive pool"
>
  @if (isLoading()) {
    <div class="flex items-center gap-4 flex-1">
      <p-skeleton shape="circle" size="2.5rem" />
      <div class="flex flex-col gap-2 flex-1">
        <p-skeleton width="10rem" height="0.75rem" />
        <p-skeleton width="14rem" height="1rem" />
      </div>
    </div>
  } @else if (hasError()) {
    <div class="flex items-center gap-3 shrink-0 min-w-0">
      <span
        class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-emerald-50 text-emerald-600 shrink-0 incentive-pool-banner__icon--error"
        aria-hidden="true"
      >
        <i class="pi pi-exclamation-triangle"></i>
      </span>
      <div class="flex flex-col min-w-0">
        <span class="text-[11px] font-semibold uppercase tracking-wider text-slate-500 leading-tight"
          >Deal Incentive Pool</span
        >
        <span class="text-sm font-semibold text-slate-800 truncate">{{ bucketLabel() }}</span>
      </div>
    </div>

    <div class="flex items-center justify-between gap-4 flex-1 min-w-0 flex-wrap ml-auto">
      <p class="m-0 text-sm text-red-700 leading-normal min-w-0">{{ errorMessage() }}</p>
      <p-button
        icon="pi pi-refresh"
        label="Retry"
        [outlined]="true"
        severity="danger"
        size="small"
        (onClick)="retry()"
      />
    </div>
  } @else {
    <div class="flex items-center gap-3 shrink-0 min-w-0">
      <span
        class="items-center justify-center w-10 h-10 rounded-full bg-emerald-50 text-emerald-600 ring-4 ring-emerald-50/50 shrink-0 hidden sm:inline-flex"
        aria-hidden="true"
      >
        <i class="pi pi-wallet text-lg"></i>
      </span>
      <div class="flex flex-col min-w-0">
        <span class="text-[11px] font-semibold uppercase tracking-wider text-slate-500 leading-tight"
          >Deal Incentive Pool</span
        >
        <span class="text-sm font-semibold text-slate-800 truncate hidden sm:flex">{{ bucketLabel() }}</span>
      </div>
    </div>

    <span class="w-px self-stretch bg-slate-200 shrink-0 hidden sm:block"></span>

    <div class="flex items-stretch gap-6 sm:gap-8 min-w-0 flex-wrap">
      <div class="flex flex-col gap-0.5 py-1">
        <span class="text-[11px] font-semibold uppercase tracking-wider text-slate-500 leading-tight">Total</span>
        <span class="text-lg font-bold text-slate-800 leading-tight whitespace-nowrap tabular-nums">{{
          total() | currencyFormat
        }}</span>
      </div>
      <div class="flex-col gap-0.5 py-1 hidden md:flex">
        <span class="text-[11px] font-semibold uppercase tracking-wider text-slate-500 leading-tight">Applied</span>
        <span class="text-lg font-bold text-slate-800 leading-tight whitespace-nowrap tabular-nums">{{
          applied() | currencyFormat
        }}</span>
      </div>
      <div class="flex flex-col gap-0.5 px-3 py-1 rounded-lg bg-emerald-50">
        <span
          class="text-[11px] font-semibold uppercase tracking-wider leading-tight incentive-pool-banner__metric-label--available"
        >
          Available
        </span>
        <span
          class="text-lg font-bold leading-tight whitespace-nowrap tabular-nums incentive-pool-banner__metric-value--available"
        >
          {{ available() | currencyFormat }}
        </span>
      </div>
    </div>

    <div class="flex-col gap-1.5 flex-1 min-w-48 max-w-sm ml-auto hidden xl:flex">
      <div class="flex items-baseline justify-between gap-2 text-xs leading-tight">
        <span class="text-slate-500">Pool consumed</span>
        <span class="font-semibold text-slate-700 tabular-nums">{{ percentageUsed() }}%</span>
      </div>
      <p-progressbar [value]="percentageUsed()" [showValue]="false" styleClass="h-2 rounded-full" />
    </div>
  }
</div>
